const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaGranja: [], listaLote: [], listaAnimal: [], listaProduto: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'ALIMENTACAO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        case 'ALIMENTACAO_LISTADO':
            return { ...state, modoTela: 'lista', lista: action.payload.data };
		case 'ALIMENTACAO_GRANJA_SELECT_LISTADO':
            return { ...state, listaGranja: action.payload.data };
		case 'ALIMENTACAO_LOTE_SELECT_LISTADO':
            return { ...state, listaLote: action.payload.data };
		case 'ALIMENTACAO_ANIMAL_SELECT_LISTADO':
            return { ...state, listaAnimal: action.payload.data };
		case 'ALIMENTACAO_PRODUTO_SELECT_LISTADO':
            return { ...state, listaProduto: action.payload.data.filter(item => !item.vacina) }; //Apenas Produto e Ração
        default:
            return state;
    }
}
